import React from "react";
import NavbarFr from "components/NavbarFr";
import FooterFr from "components/FooterFr";
import TeamsFr from "components/AboutUs/TeamsFr";
import { useSelector } from "react-redux";
import MobileNavbarFr from "components/MobileNavbarFr";
import MobileFooterFr from "components/MobileFooterFr";

function AboutUsFr () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbarFr />
            <TeamsFr />
            <MobileFooterFr />
            </>
        ) : (
            <>
            <NavbarFr />
            <TeamsFr />
            <FooterFr />
        </>
        )}
        </>
    )
};

export default AboutUsFr